import { PRIVACY } from '../sections/home/copy';
import PageShell from '../sections/home/PageShell';
import LegalLayout from '../sections/legal/LegalLayout';

// ----------------------------------------------------------------------

export default function PrivacyPage() {
  return (
    <PageShell head={PRIVACY.head}>
      <LegalLayout doc={PRIVACY} />
    </PageShell>
  );
}
